import React from "react";

export default function Reportings() {
  return (
    <>Reportings</>
  )
}